<script>
import _ from "underscore";
import { ERRORS } from "@/services/api";
import CustomStore from 'devextreme/data/custom_store';
import { DataBacked } from "@/mixins/dataBackedMixin";

export default {
  mixins: [ DataBacked ],
  data() {
  },
  computed: {
    dataGrid() {
      return this.$refs.dataGrid? this.$refs.dataGrid.instance: null;
    }
  },
  methods: {
    // delayResizeHandler(e) {
    //   if (this.delayResizeTimeout) {
    //     clearTimeout(this.delayResizeTimeout);
    //   }
    //   this.delayResizeTimeout = setTimeout(() => {
    //     if (_.isFunction(this.onResize)) {
    //       this.onResize(e);
    //     }
    //   }, 250);
    // },
    createDataSource(findFunc) {
      return new CustomStore({
        key: "id",
        load: async (options) => {
          const take = options.take || 20; // по умолчанию
          const skip = options.skip || 0;
          const pageNumber = Math.floor(skip / take) + 1;
          const page = [take, pageNumber].join(",");

          const sort = Array.isArray(options.sort)
            ? options.sort.map(s => `${s.selector},${s.desc ? "DESC" : "ASC"}`)
            : [];

          const filterJson = options.filter;
          const query = { page, sort, filterJson };
          if (this.beforeQueryData && typeof this.beforeQueryData === "function") {
            this.beforeQueryData(query);
          }
          try {
            let data = await findFunc(query);
            if (this.convertRecord && typeof this.convertRecord === "function") {
              data.pageRows.forEach(rec => this.convertRecord(rec));
            }
            data = {
              data: data.pageRows,
              totalCount: data.totalRows
            };
            // eslint-disable-next-line
            // console.debug("base::list", data);
            return data;
          } catch (err) {
            if (err.code === ERRORS.AUTH) {
              this.$store.commit("setToken", "");
              if (this.$route && this.$route.go) {
                this.$route.go();
              } else {
                document.location.reload();
              }
            } else {
              this.onDataError(err);
            }
          }
        }
      })
    },
    handleRowClick(name, e) {
      if (window.getSelection().focusOffset !== window.getSelection().anchorOffset)
        return;

      if (e.event.metaKey || e.event.ctrlKey) {
        const routeData = this.$router.resolve({ name, params: { id: e.data.id } });
        window.open(routeData.href, "_blank");
      } else {
        this.$router.push({ name, params: { id: e.data.id } });
      }
    },
    handleTabSelected(tabId) {
      if (!Array.isArray(this.tabViews) || this.tabViews.length === 0)
        return;

      //console.debug(e.addedItems[0].id);
      try {
        const query = _.extend({}, this.$route.query);
        if (tabId === this.tabViews[0].id) {
          delete query.tab;
        } else {
          query.tab = tabId;
        }
        this.$router.replace({ query });
      } catch(err) {
        if (!this) {
          // eslint-disable-next-line
          console.debug(ignore);
        }
      }
    },
    getTabIndex() {
      let index = 0;
      if (!Array.isArray(this.tabViews) || !this.$route.query)
        return index;

      this.tabViews.forEach((tab, _index) => {
        if (tab.id === this.$route.query.tab) {
          index = _index;
        }
      });
      return index;
    },
    // onResize() {
    //   if (this.countRows) {
    //     this.rowCount = this.countRows();
    //   }
    // },
  },
  mounted() {
    // setTimeout(
    //   () => window.addEventListener("resize", this.delayResizeHandler),
    //   1000
    // );

    // layout-body X X
    // dx-drawer-wrapper X X
    // dx-drawer-content X X
    // dx-scrollable.dx-scrollview X X
    // dx-scrollable.dx-scrollview > .dx-scrollable-wrapper X Y
    // dx-scrollable.dx-scrollview > .dx-scrollable-wrapper > dx-scrollable-container V Y
    // ... > dx-scrollable-content V X
    // ... > dx-scrollview-content V X
    // content V X
    // content > div
    // content-block
    // #form
    //
    setTimeout(() => {
      const div = document.querySelector(".dx-scrollable.dx-scrollview > .dx-scrollable-wrapper > .dx-scrollable-container");
      if (div) {
        if (!div.hasAttribute("tabindex")) {
          div.setAttribute("tabindex", "0");
        }
        div.focus({ preventScroll:false });
      }
    });
  },
  // beforeDestroy() {
  //   window.removeEventListener("resize", this.delayResizeHandler);
  // }
}
</script>
